{
  "title": "Name",
  "tab": "Tab",
  "empty": "Select tab or create new one",
  "dashboardChanged": "Changes have been made to the dashboard",
  "variables": {
    "title": "Tab variables",
    "edit": "Configure variables",
    "name": "Variable name",
    "type": "Variable type",
    "typeSelect": "Option list",
    "typeText": "Text",
    "multi": "Multiple values",
    "options": "Options",
    "noOptions": "No options yet. Add the first value.",
    "value": "Value",
    "label": "Label (optional)",
    "select": "Select a value",
    "enterValue": "Enter a value",
    "invalid": "Check variable names and option values",
    "duplicate": "Variable names and option values must be unique",
    "new": "New variable",
    "selectVariable": "Select a variable or add a new one",
    "removeVariable": "Delete variable"
  },
  "addTabDialog": {
    "title": "Add tab",
    "selectDashboard": "Select dashboard",
    "dashboard": "Dashboard",
    "name": "Name",
    "tab": "Tab",
    "restoreFromHistory": "Restore from history",
    "newTab": "New tab"
  },
  "menu": {
    "options": {
      "readonly": {
        "title": "Dashboard editing",
        "toggle": "Allow editing"
      },
      "filter": {
        "title": "Filter",
        "apply": "Apply",
        "clear": "Clear",
        "add": "Add"
      },
      "save": {
        "title": "Save",
        "saveDashboard": "Save dashboard"
      },
      "reload": "Reload data",
      "reset": {
        "title": "Sync with server",
        "tooltip": "Load the latest dashboard from the server"
      },
      "add": "Add widget",
      "share": "Share",
      "viewSRM": "View SRM",
      "fullscreen": "Fullscreen mode"
    },
    "widgets": {
      "thresholdsWidget": {
        "type": {
          "label": "Type",
          "range": "Number range",
          "string": "String",
          "pivotTable": "Pivot table"
        },
        "value": {
          "label": "Value",
          "placeholder": "Enter value"
        },
        "color": "Color",
        "message": {
          "label": "Message",
          "placeholder": "Enter message"
        }
      }
    }
  },
  "error": {
    "dashboardError": "Dashboard error"
  },
  "redirect": {
    "save": "Save",
    "continue": "Continue without saving",
    "changed": "Tab changed. Update current dashboard?"
  },
  "notifications": {
    "updated": "Dashboard updated",
    "tqlChanged": "TQL changed"
  },
  "widgets": {
    "cards": {
      "timeRangeDisabled": "Data is not limited by the dashboard time range",
      "updatesPaused": {
        "label": "Paused",
        "title": "Live updates are paused"
      },
      "updatesLive": {
        "label": "Live",
        "title": "Live updates are active"
      },
      "action": {
        "enable": "Pause",
        "disable": "Resume"
      }
    },
    "menu": {
      "edit": "Edit",
      "delete": "Delete",
      "clone": "Clone",
      "restore": "Restore",
      "openDashboard": "Open dashboard",
      "pip": "Picture in picture",
      "window": "Window",
      "fullscreen": "Fullscreen"
    },
    "floating": {
      "close": "Close"
    },
    "editMenu": {
      "return": "Return",
      "apply": "Apply",
      "delete": "Delete",
      "save": "Save",
      "preview": "Preview",
      "selectWidget": "Select widget",
      "widgetTags": {
        "placeholder": "Placeholder",
        "deprecated": "Deprecated",
        "beta": "Beta"
      },
      "version": {
        "outdated": "Widget version is outdated",
        "outdatedToDo": "Update widget by saving it"
      }
    },
    "legend": {
      "default": {
        "title": "Legend"
      }
    },
    "newWidget": {
      "title": "New widget",
      "new": "New",
      "existing": "Existing",
      "selectWidget": "Select widget"
    },
    "missingWidget": "Widget not found",
    "settings": {
      "title": "Title",
      "widgetTitle": "Widget title",
      "hideTitle": "Hide title",
      "unit": "Unit of measurement",
      "settingsTitle": "Settings",
      "dataLinks": {
        "title": "Data links",
        "linkTitle": "Link label",
        "dashboard": "Dashboard",
        "includeCurrentVariables": "Pass current tab variables",
        "variable": "Target variable",
        "source": "Value source",
        "sources": {
          "cell": "Current cell",
          "field": "Row field",
          "index": "Data index",
          "variable": "Tab variable",
          "literal": "Fixed value"
        },
        "sourceInputs": {
          "field": "Field path",
          "variable": "Variable name",
          "literal": "Value"
        },
        "addLink": "Add link",
        "addMapping": "Add variable mapping"
      },
      "linkedDashboard": {
        "title": "Linked dashboard",
        "dashboard": "Dashboard",
        "nodeId": "TQL node",
        "defaultDashboard": "Default dashboard",
        "addGroup": "Add group",
        "group": "Group",
        "sourceNode": "Current TQL node",
        "targetNode": "Dashboard TQL node",
        "hideDashboardButton": "Hide open dashboard button"
      },
      "filter": {
        "title": "Filter",
        "addButton": "Add",
        "nodeId": "TQL Node",
        "cis": "CIs"
      },
      "noDataPlaceholder": {
        "title": "No data placeholder",
        "enabled": "Enabled",
        "message": "Message",
        "icon": {
          "title": "Icon",
          "noData": "No data",
          "info": "Information",
          "warning": "Warning",
          "error": "Error",
          "success": "Success"
        },
        "color": "Color"
      },
      "legend": {
        "title": "Legend",
        "position": {
          "title": "Position",
          "left": "Left",
          "right": "Right",
          "top": "Top",
          "bottom": "Bottom"
        },
        "defaultSize": "Default size (%)",
        "hide": "Hide"
      },
      "curveType": {
        "title": "Curve type",
        "linear": "Linear",
        "cardinal": "Smooth",
        "step": "Step",
        "stepBefore": "Step Before",
        "stepAfter": "Step After"
      },
      "stackOffset": {
        "title": "Stack offset",
        "none": "None",
        "expand": "Normalization (Stack normilizes up to 100%)",
        "diverging": "Diverging (Values are added together)",
        "wiggle": "Wiggle (Minimizes change in slope)",
        "silhouette": "Silhouette (Stacks centered around zero)"
      },
      "bar": {
        "mode": {
          "title": "Bar mode",
          "single": "Single",
          "stacked": "Stacked",
          "stacked100": "Stacked to 100%",
          "grouped": "Grouped"
        },
        "maxBars": "Maximum bars (metrics)",
        "minBarWidth": "Minimum bar width (px)",
        "maxBarWidth": "Maximum bar width (px)",
        "valueLabels": "Show values",
        "thresholdFill": {
          "title": "Threshold fill",
          "whole": "Whole bar",
          "overflow": "Part above threshold"
        },
        "orientation": {
          "title": "Orientation",
          "vertical": "Vertical",
          "horizontal": "Horizontal"
        },
        "sort": {
          "title": "Sorting",
          "by": "Sort by",
          "value": "Value",
          "name": "Name"
        }
      },
      "lineStyle": {
        "title": "Line style",
        "color": "Color",
        "width": "Width",
        "radius": "Radius",
        "dash": {
          "title": "Line dash",
          "firstTitle": "Width",
          "secondTitle": "Space"
        }
      },
      "series": {
        "thresholdFill": {
          "title": "Threshold fill",
          "line": "Line only",
          "above": "Area above threshold"
        }
      },
      "textStyle": {
        "title": "Text style",
        "fontSize": "Font size",
        "color": "Color",
        "fill": "Fill"
      },
      "annotations": {
        "title": "Annotations",
        "type": "Type",
        "regionFilter": {
          "start": "Start",
          "end": "End",
          "color": "Color"
        },
        "text": {
          "position": "Position",
          "offsetY": "Y Offset",
          "content": "Content"
        },
        "line": {
          "start": "Start",
          "end": "End"
        }
      },
      "dataSource": {
        "dataType": "Datasource type",
        "queryType": "Query type",
        "title": "Datasource",
        "cisGrouped": "CI grouping",
        "dataTransform": {
          "title": "Data transform",
          "data": "Data",
          "transform": "Transform",
          "result": "Result",
          "noData": "Run preview"
        },
        "grouping": {
          "title": "Grouping",
          "type": "Grouping type",
          "showTQLNodes": "Show TQL nodes",
          "ci": "CI",
          "tqlNodes": "TQL nodes",
          "fallback": "TQL scope"
        },
        "missingDatasource": "Missing datasource config",
        "useLastValue": "Use last value",
        "tableName": "Table name"
      },
      "treeSettings": {
        "title": "Select TQL Node",
        "treeTitle": "Hierarchy setup ща TQL Nodes "
      },
      "dashboardMapper": {
        "title": "Dashboard mapping",
        "addGroup": "Add group",
        "tqlNode": "TQL Node",
        "group": "Group",
        "groupCI": "CI Group",
        "dashboard": "CI Dashboard",
        "dashboardTqlNode": "CIDashboard TQL node",
        "groupDashboard": "Group dashboard",
        "groupDashboardTqlNode": "Group dashboard TQL Node"
      },
      "attributeValue": {
        "attribute": "Attribute",
        "addGroup": "Add group",
        "tqlNode": "TQL Node"
      },
      "metricEditor": {
        "title": "Metrics",
        "aliasEditor": "Alias editor",
        "addGroup": "Add group",
        "add": "Add",
        "tqlNode": "TQL Node",
        "group": "Group",
        "queries": "Queries",
        "alias": {
          "type": {
            "title": "Type",
            "static": "Static",
            "dynamic": "Dynamic"
          },
          "functions": {
            "enumMap": "Enum map",
            "kvMap": "Key-value map",
            "kvRegexMap": "Key-value regex map"
          },
          "labels": {
            "title": "Labels",
            "__name__": "Metric name",
            "ci_id": "CI ID",
            "ci_name": "CI Name",
            "ci_type_id": "CI Type ID",
            "ci_type_name": "CI Type Name"
          },
          "name": "Name",
          "mapper": {
            "title": "Labels mapping",
            "source": "Source label",
            "target": "Replacement"
          },
          "metrics": {
            "title": "Metrics mapping",
            "source": "Source metrics",
            "target": "Replacement"
          }
        }
      },
      "opensearchEditor": {
        "title": "Opensearch",
        "addGroup": "Add group",
        "add": "Add",
        "tqlNode": "TQL Node",
        "group": "Group",
        "queries": "Queries",
        "index": "Index",
        "timeField": "Time field",
        "timeFieldDisabledHint": "The dashboard time range is not applied",
        "query": "DSL query"
      },
      "tableDefaultSort": {
        "title": "Table default sort",
        "column": "Column",
        "target": "Sort",
        "asc": "Ascending",
        "desc": "Descending"
      }
    },
    "charts": {
      "areaChart": {
        "name": "Area chart",
        "settings": {
          "isPercent": "Is percent"
        }
      },
      "timeSeriesBarChart": {
        "name": "Time series bar chart"
      },
      "categoryBarChart": {
        "name": "Category bar chart",
        "uncategorized": "Uncategorized"
      },
      "sankey": {
        "name": "Sankey",
        "settings": {
          "nodeAlign": {
            "title": "Node alignment",
            "center": "Center",
            "justify": "Justify",
            "left": "Left",
            "right": "Right"
          },
          "nodeWidth": "Node width (px)",
          "nodePadding": "Node padding (px)",
          "nodeLabels": "Node labels",
          "nodeLabelPlacement": {
            "title": "Node label position",
            "beside": "Beside the node",
            "inside": "Inside the node"
          },
          "nodeValues": "Node values",
          "linkValues": "Link values",
          "valueDisplay": {
            "title": "Value display mode",
            "value": "Value",
            "percent": "Percent",
            "valuePercent": "Value and percent"
          }
        }
      },
      "chord": {
        "name": "Chord",
        "settings": {
          "ringWidth": "Ring width (px)",
          "padAngle": "Gap between arcs (°)",
          "nodeLabels": "Node labels",
          "nodeValues": "Node values",
          "linkValues": "Link values",
          "valueDisplay": {
            "title": "Value display mode",
            "value": "Value",
            "percent": "Percent",
            "valuePercent": "Value and percent"
          }
        }
      },
      "heatMap": {
        "name": "Heatmap",
        "settings": {
          "maxCells": "Maximum intervals (metrics)",
          "minCellWidth": "Minimum cell width (px)",
          "minCellHeight": "Minimum cell height (px)",
          "colorMode": {
            "title": "Color scale",
            "gradient": "Gradient",
            "thresholds": "Thresholds"
          },
          "gradientLow": "Minimum color",
          "gradientHigh": "Maximum color",
          "gradientStops": {
            "title": "Intermediate gradient stops",
            "point": "Gradient stop",
            "position": "Position on scale (%)",
            "color": "Color"
          },
          "scaleMode": {
            "title": "Gradient bounds",
            "auto": "Automatic",
            "manual": "Manual"
          },
          "scaleMin": "Scale minimum",
          "scaleMax": "Scale maximum"
        },
        "invalidScale": "The scale minimum must be less than the maximum; both bounds must be numbers.",
        "invalidGradient": "Gradient stop positions must be unique numbers between 0 and 100%, with colors in HEX format.",
        "allValues": "All values"
      },
      "map": {
        "name": "Map",
        "cisWithoutCoordinates": "CIs without coordinates"
      },
      "gaugeChart": {
        "name": "Gauge"
      },
      "graph": {
        "name": "Graph",
        "settings": {
          "defaultGraphSchema": {
            "title": "Graph display"
          },
          "nestedMode": {
            "title": "Dashboard display",
            "modal": "Modal",
            "drawer": "Drawer",
            "size": "Size",
            "type": "Type"
          },
          "grid": "Grid"
        }
      },
      "text": {
        "name": "Text",
        "textTooLongToBeDisplayed": "Text too long to be displayed",
        "settings": {
          "valueDisplayMode": {
            "label": "Value display mode",
            "text": "Text",
            "codeEditor": "Code editor"
          }
        }
      },
      "pieChart": {
        "name": "Pie chart",
        "settings": {
          "radius": "Radius",
          "label": {
            "label": "Label",
            "position": {
              "label": "Position",
              "inner": "Inner",
              "outer": "Outer",
              "spider": "\"Spider\""
            },
            "content": "Content format",
            "offset": "Offset"
          },
          "annotations": "Annotations",
          "valueDisplay": {
            "title": "Value display mode",
            "value": "Value",
            "percent": "Percent",
            "valuePercent": "Percent and value"
          }
        }
      },
      "liquid": {
        "name": "Liquid"
      },
      "lineChart": {
        "name": "Line chart",
        "settings": {
          "xAxis": "X Axis",
          "yAxis": {
            "label": "Y Axis",
            "min": "Minimum",
            "max": "Maximum",
            "logScale": "Logarithmic scale"
          },
          "isStacked": "Is stacked",
          "stepType": {
            "title": "Step type",
            "empty": "None"
          },
          "point": {
            "title": "Point",
            "size": "Size",
            "color": "Color",
            "shape": {
              "title": "Shape",
              "square": "Square",
              "circle": "Circle",
              "diamond": "Diamond"
            }
          },
          "smooth": "Smooth"
        }
      },
      "opensearchTable": {
        "name": "Opensearch Table"
      },
      "hiValue": {
        "name": "HI Value",
        "ciName": "CI Name",
        "indicators": "Indicators",
        "change_status": "Change status",
        "summary": "Summary",
        "events": "Events",
        "description": "Description",
        "duration": "Duration",
        "startDate": "Start date",
        "settings": {
          "viewMode": {
            "label": "View mode",
            "cells": "Cells",
            "table": "Table"
          }
        }
      },
      "calculatedHI": {
        "name": "Calculated health indicator",
        "legend": "Statuses",
        "startedAtPrefix": "from",
        "settings": {
          "nodes": "TQL nodes",
          "hiType": "Health indicator",
          "hiTypesUnavailable": "Available HI list is temporarily unavailable",
          "clickAction": {
            "title": "Click action",
            "hi": "Health indicator",
            "dashboard": "Dashboard"
          },
          "normalizeBarChart": "Normalize bar chart"
        }
      },
      "divider": {
        "name": "Divider"
      },
      "timeline": {
        "name": "HI Timeline",
        "tooltip": {
          "start": "Start",
          "end": "End",
          "ongoing": "In progress"
        }
      },
      "singleValue": {
        "name": "Single value",
        "dataSource": {
          "metrics": "Metrics",
          "attributeValue": "Attribute value",
          "staticValue": {
            "label": "Static value",
            "value": "Value"
          },
          "opensearch": "Opensearch",
          "unableToRender": "Data cannot be rendered"
        },
        "settings": {
          "valueMapper": "Unit of measurement mapping",
          "valueMapping": {
            "label": "Mapping values",
            "source": "Exact value",
            "target": "Changed value"
          },
          "autoSize": "Autosize",
          "valuesRenderMode": {
            "title": "Values render mode",
            "panels": "Panels",
            "tabs": "Tabs"
          },
          "transparentBackground": "Transparent background",
          "thresholds": {
            "title": "Thresholds",
            "to": "To",
            "from": "From",
            "message": "Message"
          }
        }
      },
      "nestedDashboard": {
        "name": "Nested dashboard",
        "empty": "Select dashboard",
        "error": "Dashboard error",
        "resetLayout": "Reset layout",
        "search": "Search",
        "expand": "Expand",
        "collapse": "Collapse",
        "noDashboard": "No linked dashboard",
        "missingNode": "Node not found in TQL",
        "ci": "CI",
        "enrichment": "Enrichment",
        "nestedLayoutsWarning": "Current view uses custom layout"
      },
      "hiTable": {
        "name": "Alert history table",
        "ci_name": "CI name",
        "severity": "Status",
        "summary": "Summary",
        "starts_at": "Start",
        "ends_at": "End",
        "dataSource": {
          "showActiveOnly": "Active health indicators only"
        },
        "settings": {
          "datetimeFormat": "Datetime format",
          "columns": "Columns",
          "hiStatusSelector": "Default filter status"
        }
      },
      "ciTypesTable": {
        "name": "CI type table"
      },
      "pivotTable": {
        "name": "Pivot table",
        "rows": "Rows",
        "columns": "Columns",
        "aliasMapper": {
          "title": "Column/row renaming",
          "source": "Original value"
        },
        "AggrFunction": "Aggregation functions",
        "hideColumns": "Hide not existed columns",
        "thresholdsMapper": "Thresholds mapping",
        "expandDepth": "Expanded rows depth"
      }
    }
  }
}
